import React, { useEffect, useState } from "react";
import NewTopNavBar from "../NewTopNavBar";
import axios from "axios";
import { API_BASE_URL } from "../../utils/config";
import { MdArticle } from "react-icons/md";
import { FaLinkedin } from "react-icons/fa";
import { Spinner } from "react-bootstrap";
import LikeImg from "../../Img/blueLike.png";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import Select from "react-select";
import ViewImg from "../../Img/icons8-view-24.png";
import OpenPlatformNavbar from "../OpenPlatformNavbar";
import {
  Link,
  Route,
  Router,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { RiH4 } from "react-icons/ri";
import InnerHamburgerNavigation from "../InnerHamburgerNavigation";
import HamburgerNavigation from "../HamburgerNavigation";
import { useLog } from "../../context/LogContext";
const OpAnaliticsDasboard = () => {
  let bearerToken = "";
  const [totalLike, setTotalLike] = useState();
  const [totalArticle, setTotalArticle] = useState();
  const [loading, setLoading] = useState(false);
  const [totalCategories, setTotalCategories] = useState();
  const [resentWeekFiveArticles, setResentWeekFiveArticles] = useState([]);
  const [resentMonthFiveArticles, setResentMonthFiveArticles] = useState([]);

  const [currentWeekLikedPosts, setCurrentWeekLikedPosts] = useState([]);
  const [currentMonthLikedPosts, setCurrentMonthLikedPosts] = useState([]);
  const [currentweeksViewedArticle, setCurrentWeeksViewedArticle] = useState(
    []
  );
  const [currentMonthsViewedArticle, setCurrentMonthssViewedArticle] = useState(
    []
  );
  const [options, setOptions] = useState([]);
  const [categories, setCategories] = useState("");
  const [selectedTenant, setSelectedTenant] = useState(null);
  const [isDisabled, setIsDisabled] = useState(true);

  const [newArticleThisWeek, setNewArticleThisWeek] = useState([]);
  const { logApiRequest } = useLog();
  const navigate = useNavigate();
  const userRolles = localStorage.getItem("roles");
  let config = {
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    },
  };
  const currentUserId = localStorage.getItem("current_user_Id");
  const thisWeakMostLikedArticles = () => {
    const request = {
      method: "GET",
      url: `${API_BASE_URL}/wp-json/custom-like/v1/liked-posts`,
    };
    axios
      .get(`${API_BASE_URL}/wp-json/custom-like/v1/liked-posts`, config)
      .then((res) => {
        console.log("line19=", res.data);
        logApiRequest(request, res);
      })
      .catch((err) => {
        console.log(err);
        logApiRequest(request, err.response || { status: err.message });
      });
  };

  const gotToArticlePage = (postId) => {
    localStorage.setItem("postId", postId);
    navigate(`/single-article?id=${postId}`);
  };

  const getTenentData = () => {
    axios
      .get(`${API_BASE_URL}/wp-json/custom-api/v1/get-data`, config)
      .then((res) => {
        console.log("telentData=", res.data);
        setOptions(
          res.data.map((item) => ({
            value: item.id,
            label: item.tenent,
            categgory: item.category,
          }))
        );
        const selectedOption = res.data.filter((data) => {
          if (data.tenent_user_id == currentUserId) {
            return data;
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleChange = (selectedOption) => {
    console.log(`Selected:`, selectedOption);
    setSelectedTenant(null);
    setCategories(selectedOption.categgory.join(","));
    setLoading(false);
    // alert("dfdf")
  };

  const getAllTheArticles = async () => {
    const requestFst = {
      method: "GET",
      url: `${API_BASE_URL}/wp-json/custom-like/v1/liked-posts`,
    };
    axios
      .get(`${API_BASE_URL}/wp-json/custom-api/v1/get-data`, config)
      .then((res) => {
        logApiRequest(requestFst, res);

        setOptions(
          res.data.map((item) => ({
            value: item.id,
            label: item.tenent,
            categgory: item.category,
          }))
        );

        const selectedOption = res.data.filter((data) => {
          if (data.tenent_user_id == currentUserId) {
            return data;
          }
        });
        console.log("selectedOption", selectedOption);
        if (localStorage.getItem("roles") == "editor") {
          if (selectedOption.length > 0) {
            setOptions(
              selectedOption.map((item) => ({
                value: item.id,
                label: item.tenent,
                categgory: item.category,
              }))
            );
            setSelectedTenant({
              value: selectedOption[0].id,
              label: selectedOption[0].tenent,
              categgory: selectedOption[0].category,
            });
          } else {
            navigate("/default-page");
          }
        }
        let getArticleEndPoint;
        // https://your-domain.com/wp-json/custom/v1/posts_by_categories?categories=1,2,3
        const defaultCategory =
          selectedOption.length > 0
            ? selectedOption[0].category.join(", ")
            : "";
        console.log(
          "line81=",

          defaultCategory
        );
        if (categories == "" && selectedOption.length == 0) {
          getArticleEndPoint = `${API_BASE_URL}/wp-json/custom/v1/posts`;
        } else {
          console.log("line132=");
          if (categories == "") {
            getArticleEndPoint = `${API_BASE_URL}/wp-json/custom/v1/posts_by_categories?categories=${defaultCategory}`;
          } else {
            getArticleEndPoint = `${API_BASE_URL}/wp-json/custom/v1/posts_by_categories?categories=${categories}`;
          }
        }

        let request = {
          method: "GET",
          url: getArticleEndPoint,
        };
        axios
          .get(getArticleEndPoint, config)
          .then((res) => {
            console.log("line26=", res.data);
            logApiRequest(request, res);
            setTotalArticle(res.data.length > 0 ? res.data.length : 0);
            let noOfLike = 0;
            for (let i = 0; i < res.data.length; i++) {
              noOfLike = noOfLike + res.data[i].likes_count;
            }

            setTotalLike(noOfLike > 0 ? noOfLike : 0);
            console.log("line52");
            // Filter posts for the current week
            let sevenDaysAgo = new Date();
            sevenDaysAgo.setDate(new Date().getDate() - 7);
            // Get the Unix timestamp in milliseconds
            let sevenDaysAgoTimestampMillis = sevenDaysAgo.getTime();

            const today = new Date();
            const startOfWeek = new Date(
              today.setDate(today.getDate() - today.getDay())
            );
            const startDate = startOfWeek.toISOString().split("T")[0];

            const endDate = new Date().toISOString().split("T")[0];

            console.log(`start date=${startDate}  endDate=${endDate}`);
            const currentWeekPosts = res.data.filter((post) => {
              const postDate = new Date(post.date).getTime();

              return (
                postDate >= sevenDaysAgoTimestampMillis &&
                postDate <= new Date().getTime()
              );
            });
            console.log("weekpost=", currentWeekPosts);

            setResentWeekFiveArticles(
              currentWeekPosts.length > 0
                ? currentWeekPosts.slice(0, 5)
                : currentWeekPosts
            );
            const sortPostsDataByLike = res.data
              .filter((post) => post.likes_count > 0) // Filter out posts with likes_count of 0
              .sort((a, b) => {
                // Sort by likes_count in descending order
                return b.likes_count - a.likes_count;
              });

            const sortCurrentWeekPostsDataByLike = sortPostsDataByLike.filter(
              (post) => {
                return (
                  post.liked_timestamp * 1000 >= sevenDaysAgoTimestampMillis &&
                  post.liked_timestamp * 1000 <= new Date().getTime()
                );
              }
            );

            console.log("1qeqwe2", sortCurrentWeekPostsDataByLike);

            setNewArticleThisWeek(
              currentWeekPosts.length > 0 ? currentWeekPosts.length : 0
            );

            setCurrentWeekLikedPosts(
              sortCurrentWeekPostsDataByLike.length > 5
                ? sortCurrentWeekPostsDataByLike.slice(0, 5)
                : sortCurrentWeekPostsDataByLike
            );

            const sortWeeksViewedArticlesByTime = res.data.sort((a, b) => {
              if (b.unique_author_views !== a.unique_author_views) {
                return b.unique_author_views - a.unique_author_views;
              }
            });
            const sortWeeksViewedArticles = sortWeeksViewedArticlesByTime.sort(
              (a, b) => {
                if (b.unique_author_views !== a.unique_author_views) {
                  return b.unique_author_views - a.unique_author_views;
                }
              }
            );
            console.log("ViewedArticles=", sortWeeksViewedArticles);
            //
            const currentWeekViewedPosts = sortWeeksViewedArticles.filter(
              (post) => {
                console.log(
                  `postdate141= ${
                    post.post_view_time_stamp
                  } 7days ago=${sevenDaysAgoTimestampMillis} currentdate=${new Date().getTime()}`
                );

                console.log(
                  "line143=",
                  post.post_view_time_stamp >= sevenDaysAgoTimestampMillis &&
                    post.post_view_time_stamp <= new Date().getTime()
                );

                return (
                  post.post_view_time_stamp * 1000 >=
                    sevenDaysAgoTimestampMillis &&
                  post.post_view_time_stamp * 1000 <= new Date().getTime()
                );
              }
            );
            console.log("currentWeekViewedPosts=", currentWeekViewedPosts);

            //

            setCurrentWeeksViewedArticle(
              currentWeekViewedPosts.length > 5
                ? currentWeekViewedPosts.slice(0, 5)
                : currentWeekViewedPosts
            );
            // Filter posts for the current month
            // const today = new Date();

            let MonthDaysAgo = new Date();
            MonthDaysAgo.setDate(new Date().getDate() - 30);

            // Get the Unix timestamp in milliseconds
            let monthAgoTimestampMillis = MonthDaysAgo.getTime();

            // const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
            // const startDateMonth = startOfMonth.toISOString().split('T')[0];
            // const endDateMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0).toISOString().split('T')[0];
            // console.log(`start date=${startDateMonth}  endDate=${endDateMonth}`)

            const currentMonthPosts = res.data.filter((post) => {
              const postDate = new Date(post.date).getTime();
              return (
                postDate >= monthAgoTimestampMillis &&
                postDate <= new Date().getTime()
              );
            });
            setResentMonthFiveArticles(
              currentMonthPosts.length > 5
                ? currentMonthPosts.slice(0, 5)
                : currentMonthPosts
            );
            //

            console.log(
              "sortWeeksViewedArticlesByTime",
              sortWeeksViewedArticlesByTime
            );

            //
            const currentMonthsViewedPosts = sortWeeksViewedArticles.filter(
              (post) => {
                return (
                  post.post_view_time_stamp * 1000 >= monthAgoTimestampMillis &&
                  post.post_view_time_stamp * 1000 <= new Date().getTime()
                );
              }
            );
            console.log("currentWeekViewedPosts=", currentWeekViewedPosts);

            //

            //
            setCurrentMonthssViewedArticle(
              currentMonthsViewedPosts.length > 5
                ? currentMonthsViewedPosts.slice(0, 5)
                : currentMonthsViewedPosts
            );

            const sortCurrentMonthPostsDataByLike = sortPostsDataByLike.filter(
              (post) => {
                return (
                  post.liked_timestamp * 1000 >= monthAgoTimestampMillis &&
                  post.liked_timestamp * 1000 <= new Date().getTime()
                );
              }
            );

            setCurrentMonthLikedPosts(
              sortCurrentMonthPostsDataByLike.length > 5
                ? sortCurrentMonthPostsDataByLike.slice(0, 5)
                : sortCurrentMonthPostsDataByLike
            );
            setLoading(true);
          })
          .catch((err) => {
            logApiRequest(request, err.response || { status: err.message });
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
        logApiRequest(requestFst, err.response || { status: err.message });
      });
  };

  const getParentCategories = () => {
    const request = {
      method: "GET",
      url: "/wp-json/custom-category/v1/get-parent-categories?page=-1",
    };
    axios
      .get(
        `${API_BASE_URL}/wp-json/custom-category/v1/get-parent-categories?page=-1`,
        config
      )
      .then((res) => {
        console.log("categoryres298=", res);
        logApiRequest(request, res);
        setTotalCategories(res.data.length > 0 ? res.data.length : 0);
        // setLoading(true)
      })
      .catch((err) => {
        logApiRequest(request, err.response || { status: err.message });
        console.log(err);
      });
  };

  useEffect(() => {
    getAllTheArticles();
    thisWeakMostLikedArticles();
    getParentCategories();

    // getTenentData()
    // }, [categories, selectedTenant, loading]);
  }, [loading]);

  console.log("line293loading=", loading);

  console.log("resentfiveArticles=", currentMonthLikedPosts);
  return (
    <div>
      <div className="col-12 hamburger">
        <InnerHamburgerNavigation />
      </div>
      <div className="top-nav">
        {/* <TopNavBar /> */}
        {!bearerToken ? <OpenPlatformNavbar /> : <NewTopNavBar />}
      </div>
      {/* navbar */}
      <HamburgerNavigation />

      {console.log("loading365=", loading)}
      <div className="analiyics-dasboard-maindiv container-fluid pb-5">
        {loading ? (
          <div className="row ">
            {/* <div className='col-lg-2 col-md-2 col-sm-1'> */}

            {/* </div> */}
            <div className="col-lg-12 col-md-12 col-sm-10 mt-4">
              <div className="content-main-div">
                <div className="container">
                  {bearerToken &&
                    userRolles !== "author" &&
                    userRolles !== "subscriber" && (
                      <div>
                        {!bearerToken ? (
                          ""
                        ) : (
                          <div className="col-lg-3 col-md-3 col-sm-5 pb-4 pt-3 pe-4">
                            {selectedTenant?.length > 0 ? (
                              <Select
                                value={selectedTenant}
                                options={options}
                                onChange={handleChange}
                                placeholder="Select a Tenant "
                                // isDisabled={isDisabled}
                              />
                            ) : (
                              <Select
                                // value={selectedTenant}
                                options={options}
                                onChange={handleChange}
                                placeholder="Select a Tenant"
                              />
                            )}
                            {/* {selectedTenant?.length == 0 ? <Select
                    value={selectedTenant}
                    options={options}
                    onChange={handleChange}
                    placeholder="Select a Tenant "
                    isDisabled={isDisabled}

                /> : ""} */}
                          </div>
                        )}
                      </div>
                    )}
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <div className="article-count-container top-box-container blue-conatiner">
                        <p className="top-contaier-heading ">Total Articles</p>
                        <div className="">
                          <div className="number-count">{totalArticle}</div>
                          <div className="analitys-img">{FaLinkedin}</div>
                        </div>
                      </div>
                    </div>
                    {/* <div className="col-lg-4 col-md-4 col-sm-12">
                      <div className="article-count-container blue-conatiner top-box-container ">
                        <p className="top-contaier-heading ">Total Likes</p>
                        <div className="">
                          <div className="number-count">{totalLike}</div>
                          <div className="analitys-img">{FaLinkedin}</div>
                        </div>
                      </div>
                    </div> */}
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      {" "}
                      <div className="article-count-container blue-conatiner top-box-container ">
                        <p className="top-contaier-heading ">
                          New articles this week
                        </p>
                        <div className="">
                          <div className="number-count">
                            {newArticleThisWeek}
                          </div>
                          <div className="analitys-img">{FaLinkedin}</div>
                        </div>
                      </div>
                    </div>
                    {/* <div className="col-3"> <div className="article-count-container blue-conatiner">
                                            <p className="top-contaier-heading ">
                                                Total Categories
                                            </p>
                                            <div className=''>
                                                <div className="number-count">
                                                    {totalCategories}
                                                </div>
                                                <div className="analitys-img">{FaLinkedin}</div>
                                            </div>


                                        </div></div> */}
                  </div>
                  <div className="row">
                    {/* <div className="col-lg-4 col-md-4 col-sm-12 ">
                      <div className="top-container-main-div row">
                        <div className="article-content-main-div ">
                          <div className="article-count-container blue-conatiner mt-4 py-3 pb-4">
                            <p className="top-contaier-heading ">
                              Top 5 Most Liked Articles of the Month/Week
                            </p>
                          
                            <Tab.Container
                              id="left-tabs-example"
                              defaultActiveKey="first"
                            >
                              <Row>
                                <div className="d-flex">
                                  
                                  <Nav variant="pills" className="flex-column">
                                    <Nav.Item>
                                      <Nav.Link
                                        className="rounded-months"
                                        eventKey="first"
                                      >
                                        Month
                                      </Nav.Link>
                                    </Nav.Item>
                                  </Nav>

                                 
                                  <Nav variant="pills" className="flex-column">
                                    <Nav.Item>
                                      <Nav.Link
                                        className="rounded-months"
                                        eventKey="second"
                                      >
                                        Week
                                      </Nav.Link>
                                    </Nav.Item>
                                  </Nav>
                                </div>
                            
                                <Tab.Content>
                                  <Tab.Pane eventKey="first">
                                    {currentMonthLikedPosts.length > 0 ? (
                                      currentMonthLikedPosts.map(
                                        (res, index) => {
                                          // let regex = /\(([^)]+)\)/;
                                          // let match = regex.exec(res.category_name
                                          //     .name);
                                          // let valueWithinParentheses = match[1];

                                          function truncateSentence(
                                            sentence,
                                            maxChars
                                          ) {
                                            let words = sentence.split(" ");
                                            console.log("line189", words);
                                            if (sentence.length > maxChars) {
                                              return (
                                                sentence.substring(
                                                  0,
                                                  maxChars
                                                ) + " ..."
                                              );
                                            }
                                            return sentence;
                                          }
                                          return (
                                            <div
                                              className="post-main-div"
                                              onClick={() =>
                                                gotToArticlePage(res.id)
                                              }
                                            >
                                             

                                              <div className="article-containt-maindiv Category-name">
                                              
                                                {truncateSentence(
                                                  res?.title.rendered,
                                                  32
                                                )}
                                                <div className="like-main-div">
                                                  <div className="like-main-img-div">
                                                    <img
                                                      width={30}
                                                      src={LikeImg}
                                                      alt=""
                                                    />
                                                  </div>
                                                  <div className="count-number-div">
                                                    <span className="like-count ps-1 mt-0">
                                                      {res.likes_count == ""
                                                        ? 0
                                                        : res.likes_count > 99
                                                        ? "99+"
                                                        : res.likes_count}
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          );
                                        }
                                      )
                                    ) : (
                                      <h4 className="text-center fw-bold py-5">
                                        No Article found
                                      </h4>
                                    )}
                                  </Tab.Pane>
                                  <Tab.Pane eventKey="second">
                                    {currentWeekLikedPosts.length > 0 ? (
                                      currentWeekLikedPosts.map(
                                        (res, index) => {
                                          // let regex = /\(([^)]+)\)/;
                                          // let match = regex.exec(res.category_name
                                          //     .name);
                                          // let valueWithinParentheses = match[1];

                                          function truncateSentence(
                                            sentence,
                                            maxChars
                                          ) {
                                            console.log("sentace=", sentence);
                                            let words = sentence.split(" ");
                                            console.log("line189", words);
                                            if (sentence.length > maxChars) {
                                              return (
                                                sentence.substring(
                                                  0,
                                                  maxChars
                                                ) + " ..."
                                              );
                                            }
                                            return sentence;
                                          }
                                          return (
                                            <div
                                              onClick={() =>
                                                gotToArticlePage(res.id)
                                              }
                                              className="post-main-div"
                                            >
                                              

                                              <div className="article-containt-maindiv Category-name">
                                              
                                                {truncateSentence(
                                                  res?.title.rendered,
                                                  32
                                                )}
                                                <div className="like-main-div">
                                                  <div className="like-main-img-div">
                                                    <img
                                                      width={30}
                                                      src={LikeImg}
                                                      alt=""
                                                    />
                                                  </div>
                                                  <div className="count-number-div">
                                                    <span className="like-count ps-1 mt-0">
                                                      {res.likes_count == ""
                                                        ? 0
                                                        : res.likes_count > 99
                                                        ? "99+"
                                                        : res.likes_count}
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          );
                                        }
                                      )
                                    ) : (
                                      <h4 className="text-center fw-bold py-5">
                                        No Article found
                                      </h4>
                                    )}
                                  </Tab.Pane>
                                </Tab.Content>
                              </Row>
                            </Tab.Container>
                            
                          </div>
                        </div>
                      </div>
                    </div> */}
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <div className="top-container-main-div row">
                        <div className="article-content-main-div ">
                          <div className="article-count-container blue-conatiner mt-4 py-3 pb-4">
                            <p className="top-contaier-heading ">
                              Most recent Articles of the Month/Week
                            </p>
                            {/* tabs start */}
                            <Tab.Container
                              id="left-tabs-example"
                              defaultActiveKey="first"
                            >
                              <Row>
                                <div className="d-flex">
                                  {/* <Col sm={4}> */}
                                  <Nav variant="pills" className="flex-column">
                                    <Nav.Item>
                                      <Nav.Link
                                        className="rounded-months"
                                        eventKey="first"
                                      >
                                        Month
                                      </Nav.Link>
                                    </Nav.Item>
                                  </Nav>

                                  {/* </Col> */}
                                  {/* <Col sm={4}> */}
                                  <Nav variant="pills" className="flex-column">
                                    <Nav.Item>
                                      <Nav.Link
                                        className="rounded-months"
                                        eventKey="second"
                                      >
                                        Week
                                      </Nav.Link>
                                    </Nav.Item>
                                  </Nav>
                                </div>
                                <Tab.Content>
                                  <Tab.Pane eventKey="first">
                                    {resentMonthFiveArticles.length > 0 ? (
                                      resentMonthFiveArticles.map(
                                        (res, index) => {
                                          // let regex = /\(([^)]+)\)/;
                                          // let match = regex.exec(res.category_name
                                          //     .name);
                                          // let valueWithinParentheses = match[1];

                                          function truncateSentence(
                                            sentence,
                                            maxChars
                                          ) {
                                            let words = sentence.split(" ");
                                            console.log("line189", words);
                                            if (sentence.length > maxChars) {
                                              return (
                                                sentence.substring(
                                                  0,
                                                  maxChars
                                                ) + " ..."
                                              );
                                            }
                                            return sentence;
                                          }
                                          return (
                                            <div
                                              className="post-main-div"
                                              onClick={() =>
                                                gotToArticlePage(res.id)
                                              }
                                            >
                                              {/* <div className="Category-name">
                                                                                {truncateSentence(res?.title.rendered, 32)}
                                                                            </div> */}

                                              <div className="article-containt-maindiv Category-name">
                                                {/* <div className="post-title pt-2" dangerouslySetInnerHTML={{ __html: truncateSentence(res?.excerpt?.rendered, 40) }} /> */}
                                                {truncateSentence(
                                                  res?.title.rendered,
                                                  32
                                                )}
                                                <div className="like-main-div">
                                                  <div className="like-main-img-div">
                                                    <img
                                                      width={30}
                                                      src={ViewImg}
                                                      alt=""
                                                    />
                                                  </div>
                                                  <div className="count-number-div">
                                                    {console.log(
                                                      "line701=",
                                                      res.unique_author_views
                                                    )}
                                                    <span className="like-count ps-1 mt-0">
                                                      {res.unique_author_views ==
                                                      ""
                                                        ? 0
                                                        : res.unique_author_views >
                                                          99
                                                        ? "99+"
                                                        : res.unique_author_views}
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          );
                                        }
                                      )
                                    ) : (
                                      <h4 className="text-center fw-bold py-5">
                                        No Article found
                                      </h4>
                                    )}
                                  </Tab.Pane>
                                  <Tab.Pane eventKey="second">
                                    {resentWeekFiveArticles.length > 0 ? (
                                      resentWeekFiveArticles.map(
                                        (res, index) => {
                                          // let regex = /\(([^)]+)\)/;
                                          // let match = regex.exec(res.category_name
                                          //     .name);
                                          // let valueWithinParentheses = match[1];

                                          function truncateSentence(
                                            sentence,
                                            maxChars
                                          ) {
                                            console.log("sentace=", sentence);
                                            let words = sentence.split(" ");
                                            console.log("line189", words);
                                            if (sentence.length > maxChars) {
                                              return (
                                                sentence.substring(
                                                  0,
                                                  maxChars
                                                ) + " ..."
                                              );
                                            }
                                            return sentence;
                                          }
                                          return (
                                            <div
                                              onClick={() =>
                                                gotToArticlePage(res.id)
                                              }
                                              className="post-main-div"
                                            >
                                              {/* <div className="Category-name">
                                                                                {truncateSentence(res?.title.rendered, 32)}
                                                                            </div> */}

                                              <div className="article-containt-maindiv Category-name">
                                                {/* <div className="post-title pt-2" dangerouslySetInnerHTML={{ __html: truncateSentence(res?.excerpt?.rendered, 40) }} /> */}
                                                {truncateSentence(
                                                  res?.title.rendered,
                                                  32
                                                )}
                                                <div className="like-main-div">
                                                  <div className="like-main-img-div">
                                                    <img
                                                      width={30}
                                                      src={ViewImg}
                                                      alt=""
                                                    />
                                                  </div>
                                                  <div className="count-number-div">
                                                    {console.log(
                                                      "line701=",
                                                      res.unique_author_views
                                                    )}
                                                    <span className="like-count ps-1 mt-0">
                                                      {res.unique_author_views ==
                                                      ""
                                                        ? 0
                                                        : res.unique_author_views >
                                                          99
                                                        ? "99+"
                                                        : res.unique_author_views}
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          );
                                        }
                                      )
                                    ) : (
                                      <h4 className="text-center fw-bold py-5">
                                        No Article found
                                      </h4>
                                    )}
                                  </Tab.Pane>
                                </Tab.Content>
                              </Row>
                            </Tab.Container>
                            {/* tabs end */}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <div className="top-container-main-div row">
                        <div className="article-content-main-div ">
                          <div className="article-count-container blue-conatiner mt-4 py-3 pb-4">
                            <p className="top-contaier-heading ">
                              Most Viewed Articles of the Month/Week
                            </p>
                            {/* tabs start */}
                            <Tab.Container
                              id="left-tabs-example"
                              defaultActiveKey="first"
                            >
                              <Row>
                                <div className="d-flex">
                                  {/* <Col sm={4}> */}
                                  <Nav variant="pills" className="flex-column">
                                    <Nav.Item>
                                      <Nav.Link
                                        className="rounded-months"
                                        eventKey="first"
                                      >
                                        Month
                                      </Nav.Link>
                                    </Nav.Item>
                                  </Nav>

                                  {/* </Col> */}
                                  {/* <Col sm={4}> */}
                                  <Nav variant="pills" className="flex-column">
                                    <Nav.Item>
                                      <Nav.Link
                                        className="rounded-months"
                                        eventKey="second"
                                      >
                                        Week
                                      </Nav.Link>
                                    </Nav.Item>
                                  </Nav>
                                </div>
                                <Tab.Content>
                                  <Tab.Pane eventKey="first">
                                    {currentMonthsViewedArticle.length > 0 ? (
                                      currentMonthsViewedArticle.map(
                                        (res, index) => {
                                          // let regex = /\(([^)]+)\)/;
                                          // let match = regex.exec(res.category_name
                                          //     .name);
                                          // let valueWithinParentheses = match[1];

                                          function truncateSentence(
                                            sentence,
                                            maxChars
                                          ) {
                                            let words = sentence.split(" ");
                                            console.log("line189", words);
                                            if (sentence.length > maxChars) {
                                              return (
                                                sentence.substring(
                                                  0,
                                                  maxChars
                                                ) + " ..."
                                              );
                                            }
                                            return sentence;
                                          }
                                          return (
                                            <div
                                              className="post-main-div"
                                              onClick={() =>
                                                gotToArticlePage(res.id)
                                              }
                                            >
                                              {/* <div className="Category-name">
                                                                                {truncateSentence(res?.title.rendered, 32)}
                                                                            </div> */}
                                              <div className="article-containt-maindiv Category-name">
                                                {/* <div className="post-title pt-2" dangerouslySetInnerHTML={{ __html: truncateSentence(res?.excerpt?.rendered, 40) }} /> */}
                                                {truncateSentence(
                                                  res?.title.rendered,
                                                  32
                                                )}
                                                <div className="like-main-div">
                                                  <div className="like-main-img-div">
                                                    <img
                                                      width={30}
                                                      src={ViewImg}
                                                      alt=""
                                                    />
                                                  </div>
                                                  <div className="count-number-div">
                                                    {console.log(
                                                      "line701=",
                                                      res.unique_author_views
                                                    )}
                                                    <span className="like-count ps-1 mt-0">
                                                      {res.unique_author_views ==
                                                      ""
                                                        ? 0
                                                        : res.unique_author_views >
                                                          99
                                                        ? "99+"
                                                        : res.unique_author_views}
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          );
                                        }
                                      )
                                    ) : (
                                      <h4 className="text-center fw-bold py-5">
                                        No Article found
                                      </h4>
                                    )}
                                  </Tab.Pane>
                                  <Tab.Pane eventKey="second">
                                    {currentweeksViewedArticle.length > 0 ? (
                                      currentweeksViewedArticle.map(
                                        (res, index) => {
                                          // let regex = /\(([^)]+)\)/;
                                          // let match = regex.exec(res.category_name
                                          //     .name);
                                          // let valueWithinParentheses = match[1];

                                          function truncateSentence(
                                            sentence,
                                            maxChars
                                          ) {
                                            console.log("sentace=", sentence);
                                            let words = sentence.split(" ");
                                            console.log("line189", words);
                                            if (sentence.length > maxChars) {
                                              return (
                                                sentence.substring(
                                                  0,
                                                  maxChars
                                                ) + " ..."
                                              );
                                            }
                                            return sentence;
                                          }
                                          return (
                                            <div
                                              onClick={() =>
                                                gotToArticlePage(res.id)
                                              }
                                              className="post-main-div"
                                            >
                                              {/* <div className="Category-name">
                                                                                {truncateSentence(res?.title.rendered, 32)}
                                                                            </div> */}
                                              <div className="article-containt-maindiv Category-name">
                                                {/* <div className="post-title pt-2" dangerouslySetInnerHTML={{ __html: truncateSentence(res?.excerpt?.rendered, 40) }} /> */}
                                                {truncateSentence(
                                                  res?.title.rendered,
                                                  32
                                                )}
                                                <div className="like-main-div">
                                                  <div className="like-main-img-div">
                                                    <img
                                                      width={30}
                                                      src={ViewImg}
                                                      alt=""
                                                    />
                                                  </div>
                                                  <div className="count-number-div">
                                                    <span className="like-count ps-1 mt-0">
                                                      {res.unique_author_views ==
                                                      ""
                                                        ? 0
                                                        : res.unique_author_views >
                                                          99
                                                        ? "99+"
                                                        : res.unique_author_views}
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          );
                                        }
                                      )
                                    ) : (
                                      <h4 className="text-center fw-bold py-5">
                                        No Article found
                                      </h4>
                                    )}
                                  </Tab.Pane>
                                </Tab.Content>
                              </Row>
                            </Tab.Container>
                            {/* tabs end */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className='col-lg-2 col-md-2 col-sm-1'> */}

            {/* </div> */}
          </div>
        ) : (
          <div className="d-flex align-items-center mt-5 pt-5 justify-content-center">
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

export default OpAnaliticsDasboard;
